import { FC } from 'react';
import Image from 'next/image';

export const Logo: FC = () => {
	return (
		<div className="flex justify-center mb-2 sm:mb-4">
			<Image src="/assets/images/logo.svg" alt="Chime logo" width={96} height={24} />
		</div>
	);
};
